import React from 'react';
import CoreDivider, { DividerProps } from '../../../Divider';
import { st, classes } from './Divider.st.css';

const Divider = ({ className, ...props }: DividerProps) => (
  <CoreDivider {...props} className={st(classes.root, className)} />
);

Divider.displayName = 'Card.Divider';

export default Divider;
